import React from 'react';
import ReactDOM from 'react-dom';
import UPshowState from '../UPshowState';
import StateFactory from '../StateFactory';
import LiveEvent from './LiveEvent';
import StateService from '../../services/StateService';
import AudioAnnouncementsService from '../../services/AudioAnnouncementsService';
import { setAuthCookies } from '../../libs/helpers';
import { getDeviceInfo } from '../../Upshow';
import SocketService from '../../services/SocketService';
import MetricsService from '../../services/MetricsService';
import { getSystemMetrics } from '@upshow/brightsign/src';

export default class LiveEventState extends UPshowState {

    get name () {
        return 'live_event';
    }

    playerError = false;

    onError = (error) => {
        console.log('Fatal player error', error.message);
        this.playerError = true;
        this.renderLiveEvent();
    };

    solveError = (message) => {
        console.log('Fatal player error solved', message);
        this.playerError = false;
        this.renderLiveEvent();
    };

    pauseLiveEvent = () => {
        this.state.playing = false;
        this.stopRender();
    };

    playLiveEvent = () => {
        this.state.playing = true;
        this.renderLiveEvent();
    };

    stopRender () {
        ReactDOM.render(<></>, this.node);
    };

    renderLiveEvent () {
        ReactDOM.render(
            <LiveEvent
                {...this.state}
                playerError={this.playerError}
                done={() => { 
                    StateService.flagFinishedLiveEvent(this.state.state.liveEvent.id);
                }}
                error={this.onError}
                warning={(warning) => { 
                    console.error('warning', warning);
                }}
                onHeartbeat={async (data) => {
                    if (!MetricsService.isEnabled()) return;
                    
                    const deviceInfo = getDeviceInfo();
                    const system = deviceInfo.model === 'BrightSign' ? await getSystemMetrics() : null;
                    
                    const payload = {
                        type: 'heartbeat-metrics',
                        timestamp: new Date().toISOString(),
                        system,
                        player: data,
                        liveEvent: this.state.state.liveEvent
                    };
                    
                    SocketService.socket.emit('heartbeat-metrics', payload);
                }}
                solveError={this.solveError}
            />, this.node);
    }

    async preload () {
        const metadata = this.state.state.liveEvent.metadata;
        
        if (metadata.isSecure && metadata.secureUrl) {
            const secureUrlLiveEvent = new URL(metadata.secureUrl);
            secureUrlLiveEvent.searchParams.set('liveEventId',this.state.state.liveEvent.id);
            
            const { data } = await setAuthCookies(secureUrlLiveEvent.toString());
            
            if (metadata.hasDrm) {
                console.log("save drm token");
                this.state.state.liveEvent.token = data.signed;
            }
        }

        this.state.soundState.shouldSound = true;
        this.state.soundState.disableOverride = true;
        AudioAnnouncementsService.silence();

        this.renderLiveEvent();
        return super.preload();
    }
}

StateFactory.register('live_event', LiveEventState, 10);
